import type { RouterOutputs } from '@/client/utils/trpc';

type Submission = RouterOutputs['timesheets']['listSubmissions'][number];

export function isEntryLocked(date: string, submissions: Submission[]): boolean {
  return submissions.some((s) => date >= s.date_from && date <= s.date_to);
}

export function isRangeCovered(from: string, to: string, submissions: Submission[]): boolean {
  return submissions.some((s) => s.date_from <= from && s.date_to >= to);
}
